import { type InstitutionInfo } from './institutions'

const SHP_PHONE = '6643 6969' as const
const SHP_SUBMISSION_EMAIL = 'shp.msw@singhealth.com.sg' as const

const SHP_LOGO = '/assets/shp-logo.png' as const

export const SHP_COMMON = {
  appointmentPhone: SHP_PHONE,
  mssPhone: SHP_PHONE,
  openingHours: [
    { days: 'Mon - Fri', times: '8am to 1pm, 2pm to 4.30pm' },
    { days: 'Sat, Sun and PH', times: 'Closed' },
  ],
  mssEmail: SHP_SUBMISSION_EMAIL,
  logo: SHP_LOGO,
  website: 'https://polyclinic.singhealth.com.sg/',
} as const

const SHP_POLYCLINICS: Record<string, InstitutionInfo> = {
  Bedok: {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Bedok',
    address:
      'Heartbeat@Bedok 11 Bedok North Street 1 #02-01 / 03-01 Singapore 469662',
    appointmentEmail: 'bedokpolyclinic@singhealth.com.sg',
  },
  'Bukit Merah': {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Bukit Merah',
    address: 'Blk 163 Bukit Merah Central #04-3565 (Level 8) Singapore 150163',
    appointmentEmail: 'bukitmerahpolyclinic@singhealth.com.sg',
  },
  Eunos: {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Eunos',
    address: '1 Chin Cheng Ave, Singapore 429400',
    appointmentEmail: 'eunospolyclinic@singhealth.com.sg',
  },
  'Marine Parade': {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Marine Parade',
    address: 'Blk 80 Marine Parade Central #01-792 Singapore 440080',
    appointmentEmail: 'marineparadepolyclinic@singhealth.com.sg',
  },
  Outram: {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Outram',
    address:
      '3 Second Hospital Avenue #02-00 Health Promotion Board Building Singapore 168937',
    appointmentEmail: 'outrampolyclinic@singhealth.com.sg',
  },
  'Pasir Ris': {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Pasir Ris',
    address: '6 Pasir Ris Drive 8 #1M-01 Singapore 519466',
    appointmentEmail: 'pasirrispolyclinic@singhealth.com.sg',
  },
  Punggol: {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Punggol',
    address: '681 Punggol Drive, #02-01, Oasis Terraces, Singapore 820681',
    appointmentEmail: 'punggolpolyclinic@singhealth.com.sg',
  },
  Sengkang: {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Sengkang',
    address: '2 Sengkang Square #01-06 Sengkang Community Hub Singapore 545025',
    appointmentEmail: 'sengkangpolyclinic@singhealth.com.sg',
  },
  Tampines: {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Tampines',
    address: '1 Tampines Street 41, Singapore 529203',
    appointmentEmail: 'tampinespolyclinic@singhealth.com.sg',
  },
  'Tampines North': {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Tampines North',
    address: '35 Tampines Street 61, Singapore 528566',
    appointmentEmail: 'tampinesnorthpolyclinic@singhealth.com.sg',
  },
} as const

export const POLYCLINICS = { ...SHP_POLYCLINICS } as const
